import React from "react";
import HabitacionItem from "./HabitacionItem";
import styles from "../styles/habitaciones.module.css";
import { FaMagnifyingGlass } from "react-icons/fa6";

export default function HabitacionesList({
    list,
    isOpen,
    onToggle,
    onEdit,
    onDelete,
}) {
    if (!list.length) {
        return (
            <div className={`${styles.card} ${styles.soft} ${styles.empty}`}>
                <h4 style={{ margin: 0 }}>
                    <FaMagnifyingGlass style={{ fontSize: "30px" }} />
                </h4>
                <p className={styles.muted}>Prueba otros filtros o crea una habitación.</p>
            </div>
        );
    }

    return (
        <div className={styles.stack}>
            {list.map((h) => (
                <HabitacionItem
                    key={h.id}
                    habitacion={h}
                    open={isOpen(h.id)}
                    onToggle={onToggle}
                    onEdit={onEdit}
                    onDelete={onDelete}
                />
            ))}
        </div>
    );
}
